package com.eladfinish.bible.contest.screens.randomVerse.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.screens.names.ui.ChapterDialog
import com.eladfinish.bible.contest.screens.randomVerse.RandomVerseAction
import com.eladfinish.bible.contest.screens.randomVerse.RandomVerseState

@Composable
internal fun RandomVerseDialogs(
    dialogState: RandomVerseState.DialogState,
    onAction: (RandomVerseAction) -> Unit,
    onChapterDialogTitleClick: (ChapterData) -> Unit,
) {
    when (dialogState) {
        RandomVerseState.DialogState.None -> Unit
        is RandomVerseState.DialogState.ChapterDialog -> {
            val chapterData = dialogState.chapterData
            ChapterDialog(
                chapterData = chapterData,
                onDismiss = {
                    onAction(RandomVerseAction.HideDialog)
                },
                onTitleClick = {
                    onAction(RandomVerseAction.HideDialog)
                    onChapterDialogTitleClick(dialogState.chapterData)
                },
            )
        }
    }
}
